import { gql } from "@apollo/client";

export const SUBSCRIPTIONS = gql`
  query Subscriptions(
    $where: SubscriptionWhereInput
    $like: JSONObject
    $take: Int
    $skip: Int
    $gt: SubscriptionWhereInput
    $lt: SubscriptionWhereInput
  ) {
    subscriptions(
      where: $where
      like: $like
      take: $take
      skip: $skip
      gt: $gt
      lt: $lt
    ) {
      count
      data {
        id
        createdDate
        signedDate
        sendSignatureDate
        externalManagement
        locked
        status
        additionalInfo
        insurancePlan {
          id
          name
          description
          alias
          icon
          config
          params {
            rules {
              id
              name
              value
            }
          }
        }
        project {
          id
          hasResponsible
          ria
          expired
          fields
          generalCosts {
            id
            cost
            currency
            commission {
              id
              type
              value
              withholding
            }
            insurancePlan {
              id
            }
          }
          contact {
            id
            relatedPersons {
              id
              relationship
              authority
              identity {
                id
                socialRegime
                socialSecurityNumber
                fields
                user {
                  id
                  firstname
                  lastname
                  birthDate
                  gender
                  birthName
                  maritalName
                }
              }
            }
            user {
              id
              firstname
              lastname
              birthName
              maritalName
              birthDate
            }
            telecoms {
              id
              system
              value
            }
          }
          contract {
            id
            issuanceDate
          }
          author {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`;
export const SUBSCRIPTIONS_LIST = gql`
  query SubscriptionsList(
    $where: SubscriptionWhereInput
    $like: JSONObject
    $take: Int
    $skip: Int
    $gt: SubscriptionWhereInput
    $lt: SubscriptionWhereInput
    $exclude: [String]
  ) {
    subscriptionsList(
      where: $where
      like: $like
      take: $take
      skip: $skip
      gt: $gt
      lt: $lt
      exclude: $exclude
    ) {
      count
      data {
        id
        createdDate
        signedDate
        sendSignatureDate
        externalManagement
        locked
        status
        additionalInfo
        insurancePlan {
          id
          name
          description
          icon
          config
        }
        project {
          id
          hasResponsible
          ria
          expired
          fields
          generalCosts {
            id
            cost
            currency
            commission {
              id
              type
              value
              withholding
            }
            insurancePlan {
              id
            }
          }
          contact {
            id
            user {
              id
              firstname
              lastname
              birthName
              maritalName
              birthDate
            }
          }
          contract {
            id
            issuanceDate
          }
          author {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTIONS_LOG = gql`
  query Subscriptions($where: SubscriptionWhereInput, $take: Int, $skip: Int) {
    subscriptions(where: $where, take: $take, skip: $skip) {
      count
      data {
        id
        createdDate
        signedDate
        locked
        status
        additionalInfo
        project {
          id
          author {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTION = gql`
  query subscription($where: SubscriptionWhereInput) {
    subscription(where: $where) {
      id
      createdDate
      locked
      envelopeId
      signature
      status
      externalManagement
      signedDate
      additionalInfo
      issuanceDate
      expired
      attachments {
        id
        name
        type
        fileUrl
        createdDate
        user {
          id
          firstname
          lastname
        }
      }
      insurancePlan {
        id
        name
        icon
        externalId
        description
        alias
        fields
        config
        category
        product
        risk
        identifier
        level
        params {
          id
          rules {
            name
            value
          }
        }
      }
      project {
        id
        ria
        projectType
        fields
        expired
        tracer {
          id
        }
        terminationRequest {
          id
          contractNumber
          reason
          recipient
          dueDate
          madeIn
          address
          complement
          zipCode
          city
          email
          brokerageMandate {
            id
            firstName
            lastName
            currentCompany
          }
        }
        contact {
          id
          socialRegime
          socialSecurityNumber
          nationality
          familySituation
          socioProfessionalCategory
          politicallyExposedPerson
          siretNumber
          profession
          exerciseFrame
          optMadelin
          acceptContact
          acceptDigital
          telecoms {
            id
            system
            value
          }
          user {
            id
            firstname
            lastname
            gender
            phone
            birthDate
            birthName
            maritalName
          }
          relatedPersons {
            id
            relationship
            authority
            identity {
              id
              socialRegime
              socioProfessionalCategory
              socialSecurityNumber
              fields
              user {
                id
                gender
                firstname
                lastname
                birthDate
                birthName
                maritalName
              }
              telecoms {
                id
                system
                value
              }
            }
          }
          telecoms {
            id
            system
            value
          }
          fields
        }
        contract {
          id
          issuanceDate
          caseType
          saleMode
          operationNature
        }
        ownedBy {
          id
        }
      }
      payment {
        id
        type
        frequency
        debitDay
        payer {
          id
          BIC
          IBAN
          owner {
            id
            gender
            firstName
            lastName
            isAdherent
            type
            socialReason
            telecoms {
              id
              system
              value
            }
          }
        }
        receiver {
          id
          BIC
          IBAN
          owner {
            id
            gender
            firstName
            lastName
            isAdherent
            type
            socialReason
            telecoms {
              id
              system
              value
            }
          }
        }
      }
    }
  }
`;

export const COUNT_SUBSCRIPTIONS = gql`
  query CountSubscriptions(
    $where: SubscriptionWhereInput
    $gt: SubscriptionWhereInput
    $lt: SubscriptionWhereInput
  ) {
    countSubscriptions(where: $where, gt: $gt, lt: $lt)
  }
`;

export const COUNT_SUBSCRIPTIONS_METRICS = gql`
  query CountSubscriptionsMetrics(
    $where: SubscriptionWhereInput
    $gt: SubscriptionWhereInput
    $lt: SubscriptionWhereInput
  ) {
    countSubscriptionsMetrics(where: $where, gt: $gt, lt: $lt)
  }
`;
export const GET_MANAGEMENT_ATTACHMENTS = gql`
  query GetManagementAttachments($where: SubscriptionWhereInput) {
    getManagementAttachments(where: $where) {
      name
      base64
      contentType
    }
  }
`;

const subscriptions = {
  SUBSCRIPTIONS,
  COUNT_SUBSCRIPTIONS,
  COUNT_SUBSCRIPTIONS_METRICS,
  SUBSCRIPTIONS_LOG,
  SUBSCRIPTION,
  GET_MANAGEMENT_ATTACHMENTS,
};

export default subscriptions;
